module.exports = __webpack_public_path__ + "static/headshot_circle3-0611bffaa4574ed7ad30c0e3cf115215.png";